import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './app/store';
import { PrimeReactProvider } from 'primereact/api';
import '@moltech/molui/molui.css'
import 'primeicons/primeicons.css';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  //   <PrimeReactProvider value={{ unstyled: false, pt: Tailwind }}  >
  <PrimeReactProvider value={{ unstyled: false }}  >
    <Provider store={store}>
      <App />
    </Provider>
  </PrimeReactProvider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
